import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: " श्री. प्रभाकर यशवंत ठाकूर ", designation: "ग्रामपंचायत एडवण ", phone: "+91 7387240330", imageUrl: "/images/prabhakar.jpeg" },
  { name: "श्री.हरेश रमाकांत किनरे", designation: "ग्रामपंचायत एडवण", phone: "+91 7030972018", imageUrl: "/images/haresh.jpeg" },
  { name: "श्री. भूपेश माणिक मोरे", designation: "ग्रामपंचायत एडवण", phone: "+91 7620466216", imageUrl: "/images/bhupesh.jpeg" },
  { name: "श्रीम. कामिनी सुरेश तरे", designation: "ग्रामपंचायत एडवण", phone: "+91 7378301087", imageUrl: "/images/kamini.jpeg" },
  { name: "श्रीम. समिक्षा अक्षय सुमडा", designation: " ग्रामपंचायत एडवण ", phone: "+91 9209202356", imageUrl: "/images/samiksha.jpeg" },
  { name: "सौ. अस्मिता संतोष राऊत", designation: "ग्रामपंचायत एडवण", phone: "+91 9834059092", imageUrl: "/images/asmita.jpeg" },
  { name: "श्रीम. ज्योत्स्ना रविंद्र रजवाडी", designation: "ग्रामपंचायत एडवण", phone: "+91 7058602973", imageUrl: "/images/jyo.jpeg" },
  { name: "श्री. निलेश रमेश किणी", designation: "ग्रामपंचायत एडवण", phone: "+91 7798099924", imageUrl: "/images/nilesh.jpeg" },
  { name: "श्रीम. प्रतीक्षा प्रदीप तरे ", designation: "ग्रामपंचायत एडवण", phone: "+91 77560 98766", imageUrl: "/images/pratiksha.jpeg" },
  { name: " श्रीम. तृप्ती भूपेंद्र तरे ", designation: "ग्रामपंचायत एडवण", phone: "+91 9923079417", imageUrl: "/images/trupti.jpeg" },
];

const karmachariMembers = [
  /*{ name: " श्री. ", designation: "सफाई  कर्मचारी", imageUrl: "/images/sharad.jpeg" },
  { name: "श्री.  ", designation: "लिपिक  कर्मचारी", imageUrl: "/images/puru.jpeg" },
  { name: "श्री.", designation: "ग्रामपंचायत कर्मचारी", imageUrl: "/images/nikhil.jpeg" },
  { name: "श्री.", designation: "संगणक परिचालक", imageUrl: "/images/pritam.jpeg" },
  { name: "श्री.", designation: "पानी पुरवठा  कर्मचारी", imageUrl: "/images/ajay.jpeg" },*/
];


const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>
      {/* KARMACHARI SECTION */}
      <h2 className="gp-section-title">कर्मचारी</h2>

      <div className="gp-grid">
        {karmachariMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
